import { Directive, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { isExternalLink } from '@utils/common.utils';

/**
 * Use on <a [href]="..."> to get SPA navigation for internal routes.
 * External URLs (http, https, mailto, tel) and links with target="_blank" are left as normal links.
 */
@Directive({
  selector: 'a[href][appSpaLink]'
})
export class SpaLinkDirective {
  constructor(private readonly router: Router) {}

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    const anchor = event.currentTarget as HTMLAnchorElement;
    const href = anchor?.getAttribute('href')?.trim();
    const target = anchor?.getAttribute('target');

    if (target === '_blank' || isExternalLink(href)) {
      return;
    }
    event.preventDefault();
    if (href && href !== '#') {
      this.router.navigateByUrl(href);
    }
  }
}
